import type { LivescoreCompetition } from '../store/types';

import { RoundPhase } from '@shared-types/match.types';

export const getCompName = (competition: LivescoreCompetition, season = '2024') => {
  if (competition.phase === RoundPhase.PREQUALIFYING && competition.prequalName) {
    return competition.prequalName;
  }

  if (competition.phase === RoundPhase.QUALIFYING && competition.qualName) {
    return competition.qualName;
  }

  if (competition.phase === RoundPhase.TOURNAMENT && competition.id === '3' && !competition.name.includes(season)) {
    return [competition.name, season].filter(Boolean).join(' ');
  }

  return competition.name;
};
